import Loadable from 'react-loadable'

export default Loadable({
  loader: () => import(/* webpackChunkName: "forgot-password" */ './index'),
  loading: () => null,
})
